/** Default and allowed page sizes for paginated lists. */
export const DEFAULT_ROWS_PER_PAGE = 50

export const PAGE_SIZE_OPTIONS = [25, 50, 100] as const

export type PageSizeOption = (typeof PAGE_SIZE_OPTIONS)[number]

export function isAllowedPageSize(value: number): value is PageSizeOption {
  return (PAGE_SIZE_OPTIONS as readonly number[]).includes(value)
}

export function resolvePageSize(value: number | null | undefined): PageSizeOption {
  if (typeof value === 'number' && isAllowedPageSize(value)) {
    return value
  }

  return DEFAULT_ROWS_PER_PAGE
}
